"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldTypeIsSchemaLess = exports.getInputTypeFromAlias = exports.getSanitizedInputType = exports.generateValidationSchema = exports.getZodSchemaForInput = void 0;
var zod_1 = require("zod");
var constants_1 = require("./constants");
var schemas_1 = require("./schemas");
// import {
//   FormInputSchemaWithChildren,
//   OptionsInputSchema,
//   ValidationOptions,
//   cModelValueByInputTypeSchema,
// } from './schema';
var utils_1 = require("../../utils");
/**
 * Adds zod validation rules to a given zod fragment.
 *
 * e.g. given a field with:
 * ```json
 * "validation": {
 * 	"email": true
 * }
 * ```
 * , will use zod's `email` method to add the email
 * validation rule.
 *
 * @param schema
 * @param validationOpts
 * @returns A zod schema with the validation rules attached.
 */
function attachZodValidationRules(input, schema, validationOpts) {
    if (!schema) {
        console.log('No schema provided for input:', input);
        return zod_1.z.unknown();
    }
    if (!validationOpts) {
        return schema;
    }
    // If a field is required, we enforce it by requiring a minimum length of 1.
    // (provided the schema has a `min` method).
    if (validationOpts.required && 'min' in schema) {
        schema = schema.min(1, {
            message: 'form.errorTypes.min',
        });
    }
    // Field with minimum length.
    if (validationOpts.min && 'min' in schema) {
        schema = schema.min(validationOpts.min, {
            message: 'form.errorTypes.min',
        });
    }
    // Field with maximum length.
    if (validationOpts.max && 'max' in schema) {
        schema = schema.max(validationOpts.max, {
            message: 'form.errorTypes.max',
        });
    }
    // Field of type 'email'.
    // We can get to email in two ways:
    // - using the `email` type (not done here)
    // - using the `email` option in the validation rules.
    if (validationOpts.email && 'email' in schema) {
        schema = schema.email({
            message: 'form.errorTypes.email',
        });
    }
    // Set this nullish LAST — because:
    // - z.string().max(3).nullish() IS FINE
    // - z.string().nullish().max(3) IS INVALID
    var canBeNullish = !validationOpts.required;
    if (validationOpts.min) {
        canBeNullish = false;
    }
    // Fields are only required if explicitly stated.
    // If not required but there's a min length, it's implicitly required.
    if (canBeNullish) {
        // We do need to make the field optional. Some schemas (e.g. strings) won't error
        // when cleared, because zod doesn't treat an empty string as a missing value.
        // Other schemas (e.g. options) will error when empty, because of how `<q-select />` works.
        schema = schema.nullish();
    }
    return schema;
}
/**
 * Converts an ACB form input schema to a zod schema.
 * For example, given:
 *
 * ```json
 * {
 * 	"name": "name",
 * 	"type": "text",
 * 	"validation": { "required": true },
 * }
 * ```
 * , will return something like:
 * ```ts
 * return z.string().min(1);
 * ```
 *
 * This needs to match `ModelValueByInputType` (for now there's nothing that's forcing it at all).
 * @param input
 * @returns
 */
function getZodSchemaForInput(input) {
    // This breaks the switch's type guard, forcing you to
    // use `as` to cast the type to access a type's specific
    // properties. If you find a better way, go for it.
    var inputType = (0, utils_1.toFirstLetterLowerCase)(input.type);
    if (!inputType) {
        console.error('No type found for input!', input);
        return zod_1.z.unknown();
    }
    var schema = undefined;
    switch (inputType) {
        case 'repeater':
            if (!input.childFields) {
                console.error('Repeater input has no children', input);
                return zod_1.z.unknown();
            }
            schema = zod_1.z.array(generateValidationSchema(input.childFields));
            break;
        case 'options':
            if (input.multiSelect) {
                schema = zod_1.z.array(zod_1.z.string());
                break;
            }
            schema = zod_1.z.string();
            break;
        default:
            if (inputType in schemas_1.cModelValueByInputTypeSchema) {
                // no special handling required
                schema = schemas_1.cModelValueByInputTypeSchema[inputType];
            }
            else {
                schema = zod_1.z.unknown();
            }
    }
    if (!schema) {
        console.error('Could not assign a schema to input:', input);
        return zod_1.z.unknown();
    }
    if (input.validation) {
        return attachZodValidationRules(input, schema, input.validation);
    }
    // no validation - it's optional
    return schema.nullish();
}
exports.getZodSchemaForInput = getZodSchemaForInput;
function getCustomValidatorsForInput(schema) {
    var validationKeys = Object.keys(schema.validation || {});
    return validationKeys.filter(function (key) { return constants_1.cFormCustomValidators[key]; });
}
/**
 * Converts a complete ACB form fields definition into a vee-validate compatible
 * zod validation schema.
 *
 * @param schema ACB field schema
 * @returns vee-validate compatible zod validation schema
 */
function generateValidationSchema(schema, customValidators, i18nValues) {
    var _this = this;
    if (i18nValues === void 0) { i18nValues = {}; }
    if (!Array.isArray(schema)) {
        console.error('Schema is not an array', schema);
        return zod_1.z.object({});
    }
    var zSchema = zod_1.z.object(schema.reduce(function (zodSchema, formInput, index) {
        if (fieldTypeIsSchemaLess(formInput.type)) {
            return zodSchema;
        }
        var inputKey = formInput.key || formInput.id || formInput.name;
        if (!formInput.type) {
            console.error('No type found for input!', formInput);
            return zodSchema;
        }
        if (!inputKey) {
            return zodSchema;
        }
        if (!zodSchema[inputKey]) {
            var schema_1 = getZodSchemaForInput(formInput);
            if (schema_1) {
                zodSchema[inputKey] = schema_1;
            }
        }
        var customValidatorKeysForInput = getCustomValidatorsForInput(formInput);
        if (!customValidators) {
            return zodSchema;
        }
        if (!customValidatorKeysForInput.length) {
            return zodSchema;
        }
        customValidatorKeysForInput.forEach(function (customValidatorKey) {
            var _a;
            if (!(customValidatorKey in customValidators)) {
                console.error("Custom validator ".concat(customValidatorKey, " not found"));
                return;
            }
            var validationContext = (_a = formInput.validation) === null || _a === void 0 ? void 0 : _a[customValidatorKey];
            zodSchema[inputKey] = zodSchema[inputKey].refine(function (val) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, customValidators[customValidatorKey](val, 
                        // @ts-expect-error Annoying error coming from union.
                        // Tricky to fix.
                        validationContext)];
                });
            }); }, {
                // TODO Let's not leave this as is... :/
                // We need to provide i18n paths to generateValidationSchema, and potentially even the
                // interpolation function, or interpolate first and then pass the string to the schema.
                // It might even be that custom validator definitions need to provide this themselves
                // (looking at date_before and date_after)
                // message:
                // 	'THERE SHOULD BE SOME I18N HANDLING FOR THIS!!!',
                message: "form.errorTypes.".concat(customValidatorKey),
            });
        });
        return zodSchema;
    }, {}));
    return zSchema;
}
exports.generateValidationSchema = generateValidationSchema;
/**
 * Give it `TextInput` or `textInput` and it returns `textInput`.
 */
function getSanitizedInputType(_alias) {
    return (0, utils_1.toFirstLetterLowerCase)(_alias);
}
exports.getSanitizedInputType = getSanitizedInputType;
/**
 * e.g. transform `textarea` or `password` into `text`, or
 * `options` or `typeAhead` into `options`.
 */
function getInputTypeFromAlias(_alias) {
    var alias = (0, utils_1.toFirstLetterLowerCase)(_alias);
    var inputType = (0, utils_1.objectKeys)(constants_1.cInputTypeAliases).find(function (inputType) {
        var aliases = constants_1.cInputTypeAliases[inputType];
        return aliases.includes(alias);
    });
    return (inputType || alias);
}
exports.getInputTypeFromAlias = getInputTypeFromAlias;
/**
 * Some input types don't have a schema — it's fine. They
 * don't actually expect an input. They're just there to serve as display.
 */
function fieldTypeIsSchemaLess(type) {
    return constants_1.cSchemaLessInputTypes.includes(type);
}
exports.fieldTypeIsSchemaLess = fieldTypeIsSchemaLess;
